export default __webpack_public_path__ + "static/media/warning.05fbf025.svg";